import type { Middleware, Dispatch, AnyAction } from 'redux';
import { addBreadcrumbSafe } from '../utils/sentryClient';

const MAX_STRING = 800;

function prune(value: unknown): unknown {
  if (typeof value === 'string') return value.slice(0, MAX_STRING);
  if (Array.isArray(value)) return value.slice(0, 10).map(prune);
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    Object.entries(value as Record<string, unknown>).forEach(([k, v]) => {
      if (k.length > 40) return;
      out[k] = prune(v);
    });
    return out;
  }
  return value;
}

export const sentryBreadcrumbs: Middleware =
  (_store) => (next: Dispatch) => (action: AnyAction) => {
    try {
      const { type, ...rest } = action || {};
      const data = prune(rest?.payload ?? (rest as unknown));
      const safeData =
        typeof data === 'object' || Array.isArray(data)
          ? (data as any)
          : ({ value: data } as any);
      addBreadcrumbSafe({
        category: 'redux.action',
        type: 'default',
        level: 'info',
        message: type,
        data: safeData,
        timestamp: Date.now() / 1000,
      });
    } catch (_) {}
    return next(action);
  };

export default sentryBreadcrumbs;
